import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { Dropdown, DropdownContent, DropdownEllipsisTrigger, DropdownItem } from '../../../../components-v2/Dropdown';
import { brandPrimary } from '../../../../styles/colors';
import { baseStyleSheet } from '../../../../styles/styles';
import { DeleteConfirmation } from '../../../DeleteConfirmation';
import { ClipboardIcon } from '../../../svgs/icons/ClipboardIcon';
import { styleSheet } from './styles';

interface ITeamMeetingConfigCardProps {
	config: Api.ITeamMeetingConfig;
	onEdit: (config: Api.ITeamMeetingConfig) => void;
	onDelete: (config: Api.ITeamMeetingConfig) => void;
	onCopyLink: (config: Api.ITeamMeetingConfig) => void;
}

export function TeamMeetingConfigCard({ config, onEdit, onDelete, onCopyLink }: ITeamMeetingConfigCardProps) {
	const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = React.useState(false);

	const memberCount = config.meetingConfigs.length;

	const handleDeleteConfirm = (confirmed: boolean) => {
		if (confirmed) {
			onDelete(config);
		}
		setIsDeleteConfirmationOpen(false);
	};

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.moreMenu)}>
				<Dropdown>
					<DropdownEllipsisTrigger aria-label='Team meeting link options' />
					<DropdownContent>
						<DropdownItem onClick={() => onEdit(config)}>Edit</DropdownItem>
						<DropdownItem onClick={() => setIsDeleteConfirmationOpen(true)}>Delete</DropdownItem>
					</DropdownContent>
				</Dropdown>
			</div>

			<h3 className={css(styleSheet.header)} title={config.name}>
				{config.name}
			</h3>
			{config.team && config.team !== 'Default' && <div className={css(styleSheet.teamType)}>Team: {config.team}</div>}
			{config.categories && config.categories.length > 0 && (
				<div className={css(styleSheet.teamType)}>Categories: {config.categories.join(', ')}</div>
			)}
			<div className={css(styleSheet.memberCount)}>
				{memberCount} user{memberCount !== 1 ? 's' : ''}
			</div>

			<div className={css(styleSheet.copyButtonContainer)}>
				<button className={css(baseStyleSheet.ctaButtonReverseSmall)} onClick={() => onCopyLink(config)}>
					<span>
						<ClipboardIcon className={css(styleSheet.clipboardIcon)} fillColor={brandPrimary} />
						Copy Booking Link
					</span>
				</button>
			</div>

			<DeleteConfirmation
				bodyText={`Are you sure you want to delete the "${config.name}" team meeting link?`}
				isOpen={isDeleteConfirmationOpen}
				onFinish={handleDeleteConfirm}
			/>
		</div>
	);
}
